<button class="mat-mini-fab mat-accent">
  <span class="mat-button-wrapper">
    <i class="mat-icon material-icons">close</i>
  </span>
</button>
